import { cn } from './cn';

/**
 * DESIGN.md › segmented-control: a pill split into equal segments, the chosen one the teal-80
 * thumb with a white label (Library › Reading / Math). A tablist of buttons; 48px tall, the
 * tap target, rather than the Figma's 38.
 */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  label,
  className,
}: {
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  /** The control's accessible name. */
  label?: string;
  className?: string;
}) {
  return (
    <div
      role="tablist"
      aria-label={label}
      className={cn(
        'flex w-full rounded-full border border-surface-tertiary bg-surface-tertiary',
        className,
      )}
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(option.value)}
            className={cn(
              'min-h-tap-target flex-1 cursor-pointer rounded-full px-content-sm font-brand text-label-sm transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-highlight',
              selected
                ? 'bg-segment-selected text-on-segment-selected'
                : 'text-on-action-secondary hover:bg-surface-secondary',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
